import { Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { useOverviewCounts } from "../../hooks/useOverviewCounts";

/**
 * The queue counts, condensed into the page header. They take this shape once
 * a conversation is open and the cards give up their space to the chat.
 */
export const ChatStatChips = () => {
  const theme = useTheme();
  const { cards, isLoading } = useOverviewCounts();

  const toneStyles = {
    critical: {
      background: theme.palette.primitive.system.red[25],
      color: theme.palette.primitive.system.red[800],
    },
    warning: {
      background: theme.palette.primitive.system.orange[25],
      color: theme.palette.primitive.system.orange[800],
    },
    default: {
      background: theme.palette.primitive.neutrals.neutral[25],
      color: theme.palette.lightBg.medium,
    },
  };

  return (
    <Stack direction="row" sx={{ gap: "8px", flexWrap: "wrap" }}>
      {cards.map((stat) => {
        const colors = toneStyles[stat.tone];

        if (isLoading) {
          return (
            <Skeleton
              key={stat.id}
              variant="rounded"
              width={112}
              height={33}
              sx={{ borderRadius: "6px" }}
            />
          );
        }

        return (
          <Stack
            key={stat.id}
            direction="row"
            sx={{
              alignItems: "center",
              gap: "8px",
              p: "8px 12px",
              borderRadius: "6px",
              backgroundColor: colors.background,
            }}
          >
            <Typography
              variant="body-small"
              sx={{ color: colors.color }}
              noWrap
            >
              {stat.label}
            </Typography>
            <Typography variant="caption-2" sx={{ color: colors.color }}>
              {stat.value}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};
